import DataAccess from './constants';
import { genfunction } from '../helpers';
import Moment from 'moment';

const path = 'MemberValidation?CardOrMemberNo=';

export const apiMemberValidation = (params) => {

    var h = new Headers();
    h.append("Authorization", 'Basic ' + genfunction.EncodeBase64(DataAccess.userName + ':' + DataAccess.password));
    h.append('Content-Type', 'application/json');

    let url = DataAccess.apiUrl + path + params.memberNo + '&LastName=' + params.lastName;

    if(params.email && params.email != '')
    {
        url += '&Email=' + params.email;
    }

    if (params.phone && params.phone != '') {
        url += '&Phone=' + params.phone;
    }

    if (params.street && params.street != '') {
        url += '&Street1=' + params.street;
    }

    if (params.checkDate && params.checkDate != '') {
        url += '&CheckDate=' + params.checkDate;
    }


    const req = new Request(url, {
        method: 'GET',
        headers: h
    })

    return fetch(req);
}